export const constants = {
  USERNAME: 'USER_NAME',
  ROLE: 'ROLE',
  USER_ID: 'USER_ID',
  AUTH_TOKEN: 'AUTH_TOKEN',
  SESSION_EXPIRES_AT: 'SESSION_EXPIRES_AT'
};
